import { Type8c9Enum as campaignType } from '@juno/client-api/model';

const USER_MAKING_ACTION_TRUNCATED_NAME = '@User';
const AUTHOR_OF_ORIGINAL_POST = 'Jane Doe';

const WelcomeEmailPayload = {
  last_name: 'LastName-TestRecipient',
  magic_link: 'https://www.junolive.com',
  site_nickname: 'Company Site',
  logo: 'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_company_logo.png',
  banner_image: 'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_banner_image_small.png',
};

const EnrollmentUpdateEmailPayload = {
  last_name: 'LastName-TestRecipient',
  brand_image: 'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_brand_image.png',
  post_title: 'Company Learning Course Enrollment Update!',
  course_title: 'Lorem Ipsum Learning Course',
  button_link: 'https://www.junolive.com',
  button_text: 'Go to course',
};

const NewTaggedLikedFeedEmailPayload = {
  brand_image: 'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_brand_image.png',
  user_making_action_truncated_name: USER_MAKING_ACTION_TRUNCATED_NAME,
  header_content_name: 'Welcome to Feed Post Header Content Area!',
  author_of_original_post_pic:
    'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_avatar_icon_small.png',
  author_of_original_post: AUTHOR_OF_ORIGINAL_POST,
  post_title: 'A lorem ipsum feed post update',
  post_description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque sit amet accumsan tortor. Curabitur mollis, ' +
    'nulla at tincidunt vehicula, enim odio lacinia massa, a dictum dolor enim a lorem. Donec.',
  post_image: 'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_post_image.png',
  like_count: 20,
  comment_count: 5,
  button_link: 'https://www.junolive.com',
  button_text: 'Check it out',
};

const FeedPostCommentsEmailPayload = {
  brand_image: 'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_brand_image.png',
  user_making_action_truncated_name: USER_MAKING_ACTION_TRUNCATED_NAME,
  header_content_name: 'Welcome to Feed Post Header Content Area!',
  author_of_original_post_pic:
    'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_avatar_icon_small.png',
  author_of_original_post: AUTHOR_OF_ORIGINAL_POST,
  post_title: 'Comments on a lorem ipsum feed post',
  user_making_action_pic:
    'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_avatar_icon_small.png',
  user_making_action_full_name: 'Lorem Allen Ipsum',
  post_description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque sit amet accumsan tortor. Curabitur mollis, ' +
    'nulla at tincidunt vehicula, enim odio lacinia massa, a dictum dolor enim a lorem. Donec.',
  button_link: 'https://www.junolive.com',
  button_text: 'Check it out',
};

const LikeYourFeedPostCommentEmailPayload = {
  brand_image: 'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_brand_image.png',
  user_making_action_truncated_name: USER_MAKING_ACTION_TRUNCATED_NAME,
  header_content_name: 'Welcome to Feed Post Header Content Area!',
  author_of_original_post_pic:
    'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_avatar_icon_small.png',
  author_of_original_post: AUTHOR_OF_ORIGINAL_POST,
  post_title: 'Check out who liked your feed post comment!',
  author_of_comment_pic:
    'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_avatar_icon_small.png',
  author_of_comment_full_name: 'Lorem Allen Ipsum',
  post_description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque sit amet accumsan tortor. Curabitur mollis, ' +
    'nulla at tincidunt vehicula, enim odio lacinia massa, a dictum dolor enim a lorem. Donec.',
  like_count: 20,
  comment_count: 5,
  button_link: 'https://www.junolive.com',
  button_text: 'Check it out',
};

const NewForumTopicEmailPayload = {
  brand_image: 'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_brand_image.png',
  post_title: 'Check out this new forum topic!',
  button_link: 'https://www.junolive.com',
  button_text: 'Check it out',
};

const NewTaggedLikedForumEmailPayload = {
  brand_image: 'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_brand_image.png',
  user_making_action_truncated_name: USER_MAKING_ACTION_TRUNCATED_NAME,
  sub_header: 'Welcome to Forum Post Header Content Area!',
  author_of_original_post_pic:
    'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_avatar_icon_small.png',
  author_of_original_post: AUTHOR_OF_ORIGINAL_POST,
  post_title: 'A lorem ipsum forum post update',
  post_description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque sit amet accumsan tortor. Curabitur mollis, ' +
    'nulla at tincidunt vehicula, enim odio lacinia massa, a dictum dolor enim a lorem. Donec.',
  post_image: 'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_post_image.png',
  like_count: 20,
  comment_count: 5,
  button_link: 'https://www.junolive.com',
  button_text: 'Check it out!',
};

const ForumPostCommentsEmailPayload = {
  brand_image: 'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_brand_image.png',
  user_making_action_truncated_name: USER_MAKING_ACTION_TRUNCATED_NAME,
  sub_header: 'Welcome to Forum Post Header Content Area!',
  author_of_original_post_pic:
    'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_avatar_icon_small.png',
  author_of_original_post: AUTHOR_OF_ORIGINAL_POST,
  post_title: 'Comments on a Lorem Ipsum forum post',
  user_making_action_pic:
    'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_avatar_icon_small.png',
  user_making_action_full_name: 'Lorem Allen Ipsum',
  post_description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque sit amet accumsan tortor. Curabitur mollis, ' +
    'nulla at tincidunt vehicula, enim odio lacinia massa, a dictum dolor enim a lorem. Donec.',
  button_link: 'https://www.junolive.com',
  button_text: 'Check it out!',
};

const LikeYourForumPostCommentEmailPayload = {
  brand_image: 'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_brand_image.png',
  user_making_action_truncated_name: USER_MAKING_ACTION_TRUNCATED_NAME,
  sub_header: 'Welcome to Forum Post Header Content Area!',
  author_of_original_post_pic:
    'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_avatar_icon_small.png',
  author_of_original_post: AUTHOR_OF_ORIGINAL_POST,
  post_title: 'Check out who liked your forum post comments!',
  author_of_comment_pic:
    'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_avatar_icon_small.png',
  author_of_comment_full_name: 'Lorem Allen Ipsum',
  post_description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque sit amet accumsan tortor. Curabitur mollis, ' +
    'nulla at tincidunt vehicula, enim odio lacinia massa, a dictum dolor enim a lorem. Donec.',
  like_count: 20,
  comment_count: 5,
  button_link: 'https://www.junolive.com',
  button_text: 'Check it out!',
};

const ReportedContentEmailPayload = {
  brand_image: 'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_brand_image.png',
  post_title: 'Check out this new forum topic!',
  button_link: 'https://www.junolive.com',
  button_text: 'Check it out',
};

const DeletedContentEmailPayload = {
  brand_image: 'https://cdn-juno.s3.amazonaws.com/assets/ui/generic_email_brand_image.png',
  post_title: 'Check out this new forum topic!',
  button_link: 'https://www.junolive.com',
  button_text: 'Check it out',
};

const DailyDigestEmailPayload = {
  type: 'DAILY_DIGEST',
  primary_color: '#52297f',
  welcome_text: 'Hi,',
  welcome_description:
    "This is your daily digest showing information of the most recent activity in the community for the last 24 hours. See what you've missed below...",
  email: 'test@email.com',
  first_name: 'Johnny',
  logo_url:
    'https://res.cloudinary.com/dxx7aeiow/image/upload/v1729695877/aypdgfs9autgxfg7undn.png',
  hero_banner_url:
    'https://res.cloudinary.com/dxx7aeiow/image/upload/v1722225959/e1k6ryhezehcgybe5uhz.png',
  promo_banner_url:
    'https://res.cloudinary.com/dxx7aeiow/image/upload/v1722225959/e1k6ryhezehcgybe5uhz.png',
  new_followers: '24',
  follower_growth: '15',
  follower_data_points: [10, 20, 15, 30, 25],
  follower_chart_points:
    '0,50 10,38 20,42 30,35 40,37 50,30 60,33 70,28 80,32 90,25 100,28 110,24 120,26 130,22 140,24 150,20 160,23 170,18 180,21 190,17 200,20 210,18 220,22 230,20 240,25 250,23 260,28 270,26 280,32 290,30 300,35',
  views_count: 67,
  views_percentage: 32,
  all_events_link: 'https://example.com/events',
  community_name: 'Growthzone Community',
  company_domain: 'growthzone.com',
  contact_link: 'https://example.com/contact',
  privacy_link: 'https://example.com/privacy-policy',
  gz_logo_url:
    'https://res.cloudinary.com/dxx7aeiow/image/upload/v1729695877/aypdgfs9autgxfg7undn.png',
  discussionGroups: [
    {
      group_name: 'Top Discussion Group Name',
      group_image_url:
        'https://res.cloudinary.com/dxx7aeiow/image/upload/v1721246441/uaiy6ldt7otwibadeuyp.jpg',
      title:
        'We believe associations are a lifeline that helps communities and Industries Thrive While Discussion Title Wraps to Max 2 Lines with Truncation',
      description:
        'Discussing our mission, values, and culture can help new employees understand what sets the company apart and how they can contribute to its success. Topics may include discussing recent company achievements, employee initiatives, and examples of living out the company values.',
      followers_count: '17',
      post_count: '21.7k',
      view_count: '3.2k',
      group_link: 'https://yourdomain.com/path/to/full-digest',
      isEven: false,
    },
  ],
  notifications: [
    {
      user_name: 'Scott Thompson',
      profile_image:
        'https://res.cloudinary.com/dxx7aeiow/image/upload/v1719187544/civnmyi2qjsuksaljw7o.jpg',
      action: 'has posted in',
      related_content: 'Introductions and Icebreakers',
      time_ago: '9 hours ago',
      content: '"Amateur beer guru. Freelance content creator and social media enthusiast."',
      view_link: 'https://example.com/post/123',
      is_read: false,
    },
  ],
  events: [
    {
      title: 'Design Review',
      start_time: 'Thursday, Nov 30 @ 12:25pm EST',
      end_time: 'Thursday, Nov 30 @ 1:25pm EST',
      location: 'Online',
      image_url:
        'https://juno-vnext-test.s3.amazonaws.com/5d63fb99-545a-4176-84ce-472229d5a3f4/quino-al-mBQIfKlvowM-unsplash.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAQDIFOJERAXQTKQO4%2F20241030%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20241030T182816Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=55ad70513c768bd3ebdcc13b43c0d0706eb4cfed697065e47f9d9cf7d9c8a295',
    },
  ],
};

const EventRemindersEmailPayload = {
  welcome_text: 'Hi,',
  event_title: 'Test Event Title',
  event_start: 'Starts in 15 minutes Today at 12:00 UTC',
  image_url:
    'https://res.cloudinary.com/dxx7aeiow/image/upload/v1721246441/uaiy6ldt7otwibadeuyp.jpg',
  button_link: 'https://example.com/events',
};

const CampaignTypeToTestEmailSerializerFieldName: { [key in campaignType]: string } = {
  ['CUSTOM']: 'temporary_string',
  ['WELCOME']: 'welcome_email_fields',
  ['COURSE_ENROLLMENT']: 'enrollment_update_fields',
  ['COURSE_WAITLIST']: 'enrollment_update_fields',
  ['NEW_FORUM_TOPIC']: 'new_forum_topic_fields',
  ['NEW_FORUM_POST']: 'new_tagged_liked_forum_post_fields',
  ['NEW_FEED_POST']: 'new_tagged_liked_feed_post_fields',
  ['TAGGED_FORUM_POST']: 'new_tagged_liked_forum_post_fields',
  ['TAGGED_FEED_POST']: 'new_tagged_liked_feed_post_fields',
  ['COMMENT_FORUM_POST']: 'comments_forum_post_fields',
  ['COMMENT_FEED_POST']: 'comments_feed_post_fields',
  ['REPLY_YOUR_COMMENT_FORUM']: 'comments_forum_post_fields',
  ['REPLY_COMMENT_YOUR_FORUM_POST']: 'comments_forum_post_fields',
  ['REPLY_YOUR_COMMENT_FEED']: 'comments_feed_post_fields',
  ['REPLY_COMMENT_YOUR_FEED_POST']: 'comments_feed_post_fields',
  ['LIKE_FORUM_POST']: 'new_tagged_liked_forum_post_fields',
  ['LIKE_FEED_POST']: 'new_tagged_liked_feed_post_fields',
  ['LIKE_YOUR_FORUM_COMMENT']: 'like_your_forum_comment_fields',
  ['LIKE_YOUR_FEED_COMMENT']: 'like_your_feed_comment_fields',
  ['REPORTED_CONTENT']: 'reported_content_fields',
  ['DELETED_CONTENT']: 'deleted_content_fields',
  ['DAILY_DIGEST']: 'daily_digest_fields',
  ['EVENT_REMINDERS_15_MIN']: 'event_reminders_15_mins_fields',
  ['EVENT_REMINDERS_72_HR']: 'event_reminders_72_hr_fields',
};

const CampaignTypeToTestEmailPayload: { [key in campaignType]: object } = {
  ['CUSTOM']: {},
  ['WELCOME']: WelcomeEmailPayload,
  ['COURSE_ENROLLMENT']: EnrollmentUpdateEmailPayload,
  ['COURSE_WAITLIST']: EnrollmentUpdateEmailPayload,
  ['NEW_FORUM_TOPIC']: NewForumTopicEmailPayload,
  ['NEW_FORUM_POST']: NewTaggedLikedForumEmailPayload,
  ['NEW_FEED_POST']: NewTaggedLikedFeedEmailPayload,
  ['TAGGED_FORUM_POST']: NewTaggedLikedForumEmailPayload,
  ['TAGGED_FEED_POST']: NewTaggedLikedFeedEmailPayload,
  ['COMMENT_FORUM_POST']: ForumPostCommentsEmailPayload,
  ['COMMENT_FEED_POST']: FeedPostCommentsEmailPayload,
  ['REPLY_YOUR_COMMENT_FORUM']: ForumPostCommentsEmailPayload,
  ['REPLY_COMMENT_YOUR_FORUM_POST']: ForumPostCommentsEmailPayload,
  ['REPLY_YOUR_COMMENT_FEED']: FeedPostCommentsEmailPayload,
  ['REPLY_COMMENT_YOUR_FEED_POST']: FeedPostCommentsEmailPayload,
  ['LIKE_FORUM_POST']: NewTaggedLikedForumEmailPayload,
  ['LIKE_FEED_POST']: NewTaggedLikedFeedEmailPayload,
  ['LIKE_YOUR_FORUM_COMMENT']: LikeYourForumPostCommentEmailPayload,
  ['LIKE_YOUR_FEED_COMMENT']: LikeYourFeedPostCommentEmailPayload,
  ['REPORTED_CONTENT']: ReportedContentEmailPayload,
  ['DELETED_CONTENT']: DeletedContentEmailPayload,
  ['DAILY_DIGEST']: DailyDigestEmailPayload,
  ['EVENT_REMINDERS_15_MIN']: EventRemindersEmailPayload,
  ['EVENT_REMINDERS_72_HR']: EventRemindersEmailPayload,
};

const email_type_to_unsubscribe_group_mapping: { [key in campaignType]: string } = {
  COURSE_ENROLLMENT: 'LMS Enrollment Activity',
  COURSE_WAITLIST: 'LMS Waitlist Activity',
  NEW_FORUM_TOPIC: 'New Forum Topics',
  NEW_FORUM_POST: 'Forum Activity',
  NEW_FEED_POST: 'Social Feed Activity',
  TAGGED_FORUM_POST: 'Tagged on a post',
  TAGGED_FEED_POST: 'Tagged on a post',
  COMMENT_FORUM_POST: 'Responses on posts & comments',
  COMMENT_FEED_POST: 'Responses on posts & comments',
  REPLY_YOUR_COMMENT_FORUM: 'Responses on posts & comments',
  REPLY_COMMENT_YOUR_FORUM_POST: 'Responses on posts & comments',
  REPLY_YOUR_COMMENT_FEED: 'Responses on posts & comments',
  REPLY_COMMENT_YOUR_FEED_POST: 'Responses on posts & comments',
  LIKE_FORUM_POST: 'Likes on posts & comments',
  LIKE_YOUR_FEED_COMMENT: 'Likes on posts & comments',
  LIKE_YOUR_FORUM_COMMENT: 'Likes on posts & comments',
  LIKE_FEED_POST: 'Likes on posts & comments',
  CUSTOM: 'lorem ipsum holder',
  WELCOME: 'lorem ipsum holder',
  REPORTED_CONTENT: 'Content being reported',
  DELETED_CONTENT: 'Content being deleted',
  DAILY_DIGEST: 'Daily Digest',
  EVENT_REMINDERS_15_MIN: 'Event Reminders 15 minutes',
  EVENT_REMINDERS_72_HR: 'Event Reminders 72 hours',
};

export {
  CampaignTypeToTestEmailPayload,
  CampaignTypeToTestEmailSerializerFieldName,
  email_type_to_unsubscribe_group_mapping,
  WelcomeEmailPayload,
};
